export const pointsToRect = (p1, p2) => {
    const x = Math.min(p1.x, p2.x);
    const y = Math.min(p1.y, p2.y);
    return {
        x, y,
        width : Math.max(p1.x, p2.x) - x,
        height: Math.max(p1.y, p2.y) - y,
    };
};
